import React, { useContext, useRef } from 'react';
import styled from 'styled-components';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';
import cloneDeep from 'lodash.clonedeep';
import TypeBottleColor from './TypeBottleColor';
import TypeBottleSize from './TypeBottleSize';
import TypeImage from './TypeImage';
import TypeOtherColor from './TypeOtherColor';

const Component = ({ stepId, variants, type, source }) => {
  const [dataState] = useContext(dataStore);
  const [appState, setAppState] = useContext(appStore);
  const containerRef = useRef();
  const productSource = dataState[source];
  const selectedId = appState.steps[stepId].id;

  // 日本語のサンプルデータ
  // Selector: {
  //   button01: '決定'
  // }

  const changeOption = (id) => {
    const newState = cloneDeep(appState);
    newState.steps[stepId].id = id;
    setAppState(newState);
  };

  const renderOptions = () => {
    const props = {
      variants: variants,
      products: productSource.products,
      selectedId: selectedId,
      onClick: changeOption,
    };

    switch (type) {
      case 'bottleColor' :
        return <TypeBottleColor {...props} />;
      case 'image' :
        return <TypeImage {...props} />;
      case 'bottleSize':
        // ボトルサイズだけ productSource をそのまま渡す
        return <TypeBottleSize {...props} products={productSource} />;
      default:
        return <TypeOtherColor {...props} />;
    }
  };

  return (
    <Container ref={containerRef}>
      <ContentWrapper>
        {renderOptions()}
      </ContentWrapper>
    </Container>
  );
};

export default Component;

const Container = styled.div`
`;

const ContentWrapper = styled.div`
`;